import { lazy, Suspense } from 'react';
import { createBrowserRouter, createHashRouter, Navigate } from 'react-router-dom';

import { Skeleton } from '../components/Skeleton.js';

import { isDemoMode } from './demoBootstrap.js';
import { Shell } from './Shell.js';

const Chat = lazy(() => import('../features/chat/Chat.js').then((m) => ({ default: m.Chat })));
const Tools = lazy(() => import('../features/tools/Tools.js').then((m) => ({ default: m.Tools })));
const History = lazy(() =>
  import('../features/history/History.js').then((m) => ({ default: m.History })),
);
const Library = lazy(() =>
  import('../features/library/Library.js').then((m) => ({ default: m.Library })),
);
const Settings = lazy(() =>
  import('../features/settings/Settings.js').then((m) => ({ default: m.Settings })),
);
const SignIn = lazy(() =>
  import('../features/auth/SignIn.js').then((m) => ({ default: m.SignIn })),
);
const Register = lazy(() =>
  import('../features/auth/Register.js').then((m) => ({ default: m.Register })),
);
const NotFound = lazy(() =>
  import('../features/notFound/NotFound.js').then((m) => ({ default: m.NotFound })),
);

const screen = (node: JSX.Element) => (
  <Suspense
    fallback={
      <div className="flex h-full flex-col gap-3 p-4">
        <Skeleton className="h-12 w-2/3" />
        <Skeleton className="h-32 w-full" />
        <Skeleton className="h-20 w-full" />
      </div>
    }
  >
    {node}
  </Suspense>
);

const buildRouter = isDemoMode ? createHashRouter : createBrowserRouter;

export const router = buildRouter([
  {
    path: '/',
    element: <Shell />,
    children: [
      { index: true, element: screen(<Chat />) },
      { path: 'tools', element: screen(<Tools />) },
      { path: 'history', element: screen(<History />) },
      { path: 'library', element: screen(<Library />) },
      { path: 'settings', element: screen(<Settings />) },
      { path: '*', element: screen(<NotFound />) },
    ],
  },
  {
    path: '/sign-in',
    element: isDemoMode ? <Navigate to="/" replace /> : screen(<SignIn />),
  },
  {
    path: '/register',
    element: isDemoMode ? <Navigate to="/" replace /> : screen(<Register />),
  },
]);
